import React, { useState, useEffect } from 'react'
import {
	Grid,
	Typography,
} from '@material-ui/core'
import { withRouter } from 'react-router-dom'
import useStyles from './styles'
import logo from './compkit.png'
import {Redirect} from 'react-router-dom'
import axios from 'axios'

function Verify(props) {
	var classes = useStyles()

	var [error, setError] = useState(false)
	var [redirect, setRedirect]  = useState(false)

    useEffect(() => {
		let queryParam = props.location.search
		let startIndex = queryParam.indexOf('=')
		let token = queryParam.slice(startIndex + 1)
		axios.post('/api/users/verify_email', { token }).then(res => {
			if (res.data.status) {
				setRedirect({ redirect: true })
			} else {
				setError(true)
			}
		}).catch(e => {
			setError(true)
		})
	}, [props.location.search])

	return (
		redirect ? <Redirect to = "/"/> :
		error ?
		<Grid container className={classes.container}>
			<div className={classes.formContainer}>
				<div className={classes.form}>
					<div className={classes.logotypeContainer}>
						<img src={logo} alt="logo" className={classes.logotypeImage} />
					</div>
                    <span className={classes.errorMessage}>Unable to Verify account signup</span>
				</div>
				<Typography color="primary" className={classes.copyright}>
					© 2019 CompKit, LLC. All rights reserved.
				</Typography>
			</div>
		</Grid>
		:
		null
	)
}

export default withRouter(Verify)
